const initWordTransition = (data) => {
  let parser = new DOMParser();

  let dom = parser.parseFromString(data.next.html, "text/html");
  let nextPage = dom.querySelector(".words");
  document.querySelector(".words").innerHTML = nextPage.innerHTML;
};
export default initWordTransition;
